import {AfterViewInit, Component, Directive, Input, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';

import {ToastrService} from 'ngx-toastr';
import {language} from '../../../language/vn';
import {CommandUtil} from '../../../global/commandutil';
import {DatePipe} from '@angular/common';
import {Sessioncommand} from '../../../global/sessioncommand';
import {NavItemService} from '../../../service/staff/service-navitem';
import {environment} from '../../../../environments/environment';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {Meeting} from '../../../models/info/meeting';
import {MeetingXuLy} from '../../../models/info/meetingxuly';
import {MeetingComment} from '../../../models/info/meetingcomment';
import {MeetingService} from '../../../service/info/service-meeting';
import {MeetingFileService} from '../../../service/info/service-meetingfile';
import {MeetingXuLyService} from '../../../service/info/service-meetingxuly';
import {MeetingCommentService} from '../../../service/info/service-meetingcomment';
import {DanhSachTHMeetingComponent} from './danhsach.component';
import {MeetingFile} from '../../../models/info/meetingfile';
import {DomSanitizer} from '@angular/platform-browser';
@Component({
  templateUrl: './ykientonghop.component.html',
  encapsulation: ViewEncapsulation.None

})
export class YKTongHopMeetingComponent implements OnInit, AfterViewInit {
  public id: number = -1;
  public language = language;
  public showAction = true;
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public  onClose: Subject<boolean>;
  public meetingItem: Meeting = new Meeting();
  public meetingXuLyItem: MeetingXuLy = new MeetingXuLy();
  public meetingCommentList: MeetingComment[] = [];
  public meetingFiles: MeetingFile[] = [];
  public maNguoiXuLy: number = Sessioncommand.staffId;
  public daPhatBieuList: MeetingXuLy[] = [];
  public chuaPhatBieuList: MeetingXuLy[] = [];
  public meetingXuLyList: MeetingXuLy[] = [];
  constructor(
    public meetingService: MeetingService,
    public toastr: ToastrService,
    public datepipe: DatePipe,
    public commandUtil: CommandUtil,
    public meetingFileService: MeetingFileService,
    public meetingXuLyService: MeetingXuLyService,
    public navItemService: NavItemService,
    public bsModalService: BsModalService,
    public _bsModalRef: BsModalRef,
    public meetingCommentService: MeetingCommentService,
    public sanitizer: DomSanitizer

  ) {
  }
  ngAfterViewInit() {
  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }

  public getXuLyId(sId: number, s: boolean): string
  {
    if(this.meetingItem!= null && sId == this.meetingItem.maNguoiChuTri)
      return   (s === true ?  this.meetingItem.thoiGianXemLanDau: this.meetingItem.thoiGianXemLanCuoi);
    let xl: MeetingXuLy = this.meetingXuLyList.find(x => x.maNguoiXuLy === sId);
    return xl == null ? "" : (s === true ?  xl.thoiGianXemLanDau: xl.thoiGianXemLanCuoi);

  }
  public edit(id: number) {
    this.id = id;

    this.loadComment(id);
    this.meetingService.getById(id).subscribe(data => this.meetingItem = data);
    this.meetingFileService.findAllByMeetingId(id).subscribe( data => this.meetingFiles = data);
    this.meetingXuLyService.findByMaYeuCau(id).subscribe( data => {this.meetingXuLyList = data;
      this.daPhatBieuList = this.meetingXuLyList.filter( x => x.trangThai === environment.daphatbieu);
      this.chuaPhatBieuList = this.meetingXuLyList.filter( x => x.trangThai === environment.chuaphatbieu);

    });
    this.meetingXuLyService.getByMaVBAndMXL(id, Sessioncommand.staffId).subscribe(
      datax => this.meetingXuLyItem = datax);

  }
  public showXuLy(meetingList: MeetingXuLy[])
  {
    const modalEdit = this.bsModalService.show(DanhSachTHMeetingComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<DanhSachTHMeetingComponent>modalEdit.content).edit(
      meetingList
    );
    (<DanhSachTHMeetingComponent>modalEdit.content).onClose.subscribe(result => {
    });
  }
  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
  public loadComment(id: number)
  {
    this.meetingCommentService.getCountByKeyword(id, Sessioncommand.staffId).subscribe( data => this.totalItems = data);
    this.meetingCommentService.findAllByPaging(id, Sessioncommand.staffId, this.currentPage, this.maxSize).subscribe( data => this.meetingCommentList = data);
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.loadComment(this.id);
  }

}

